export enum DBLocalIconRole {
    USER = 'solar:user-line-duotone',
    ADMIN = 'solar:shield-user-line-duotone',
    TEAMLEADER = 'mdi-account-supervisor',
    SUPERADMIN = 'mdi-security',
    GUEST = 'mdi-account-question',
    NOROLE = 'mdi-account-off',
}

export enum DBLocalGenericIcon {
    passwordOn = 'mdi-eye-outline',
    passwordOff = 'mdi-eye-off-outline',
    plus = 'solar:add-square-line-duotone',
    info = 'mdi-info',
    upgrade = 'mdi-crown-outline ',
    search = 'mdi-magnify',
    close = 'solar:close-square-line-duotone',
    home = 'solar:home-2-line-duotone',
    save = 'solar:diskette-bold-duotone',
    reset = 'solar:smart-vacuum-cleaner-line-duotone',
    next = 'solar:arrow-right-bold-duotone',
    edit = 'solar:pen-line-duotone',
    delete = 'solar:eraser-circle-line-duotone',
    export = 'solar:export-line-duotone',
    back = 'solar:arrow-left-bold-duotone',
    send = 'solar:map-arrow-right-bold-duotone',
    complete = 'solar:check-circle-line-duotone',
    cancel = 'solar:close-circle-line-duotone',
    valid = 'solar:check-circle-line-duotone',
    notValid = 'solar:shield-warning-line-duotone',
    NOFILTER = 'solar:tornado-small-bold-duotone',

    ADVANCED_SETTINGS = 'mdi-cogs',
    NONE = 'mdi-close-circle-outline',
    USERS = 'mdi-account-group-outline',
    USER_ADD = 'mdi-account-plus-outline',
    USER_ADMIN = 'solar:shield-user-line-duotone',
    USER_STANDARD = 'mdi-account',
    USER_SUPERADMIN = 'mdi-security',
    USER_TEAMLEADER = 'mdi-account-supervisor-outline',

    COMPANY = 'mdi-office-building-marker-outline',
    LISTCOMPANYCLIENT = 'solar:users-group-rounded-bold-duotone',
    LISTCOMPANYSELLER = 'solar:user-speak-line-duotone',

    MATERIAL_PVC = 'solar:bag-2-line-duotone',
    MATERIAL_ALUMINIUM = 'solar:notes-line-duotone',

    PANTONE = 'mdi-palette-swatch-outline',
    COLOR = 'mdi-brush-variant',
    OPTIONAL = 'solar:checklist-minimalistic-line-duotone',
    OPTIONAL_ALTEZZA_POSIZIONAMENTO = 'solar:ruler-line-duotone',
    OPTIONAL_BANDELLE = 'solar:align-left-line-duotone',
    OPTIONAL_DOGA = 'solar:winrar-line-duotone',
    OPTIONAL_FERMASCURI = 'solar:double-alt-arrow-down-bold-duotone',
    OPTIONAL_FERRAMENTA_SOSTEGNO_ESTERNA = 'solar:maximize-square-3-line-duotone',
    //OPTIONAL_FERRAMENTA_SOSTEGNO_INTERNA = 'solar:flip-horizontal-bold-duotone',
    OPTIONAL_CARDINI = 'solar:ferris-wheel-bold-duotone',
    OPTIONAL_MURATURA = 'solar:align-top-line-duotone',
    OPTIONAL_APERTURA = 'solar:folder-open-line-duotone',
    OPTIONAL_CHIUSURA = 'solar:closet-2-line-duotone',
    OPTIONAL_APPLICAZIONE = 'solar:card-2-line-duotone',
    OPTIONAL_PANTONE = 'solar:palette-line-duotone',
    OPTIONAL_TELAIO = 'solar:sticker-square-line-duotone',
    OPTIONAL_BATTUTA = 'solar:crop-minimalistic-line-duotone',
    OPTIONAL_PAREGGIATORE = 'solar:align-vertical-justify-center-bold-duotone',
    OPTIONAL_CHIUSURA_SUPERIORE = 'solar:arrow-up-bold-duotone',
    OPTIONAL_CHIUSURA_INFERIORE = 'solar:arrow-down-bold-duotone',
    OPTIONAL_CONTROTELAIO = 'solar:video-frame-line-duotone',
    OPTIONAL_SPALLA = 'solar:sidebar-minimalistic-line-duotone',
    OPTIONAL_SEZIONE_MURO = 'solar:soundwave-line-duotone',
    OPTIONAL_SOLUZIONE_CHIUSURA_SERRATURA = 'solar:lock-line-duotone',
    OPTIONAL_SIDE4 = 'solar:box-minimalistic-line-duotone',

    ACCESSORY_POSA = 'solar:inbox-archive-line-duotone',

    MEASUREGROUP = 'solar:ruler-angular-line-duotone',
    MEASURE = 'solar:ruler-line-duotone',
    MEASURE_ALTEZZA = 'material-symbols:height',
    MEASURE_LARGHEZZA = 'material-symbols:width',

    SUPERADMIN_VARIABLES = 'solar:archive-check-line-duotone',

    REGISTRY_CLIENT = 'solar:user-id-line-duotone',

    QUOTE_PVC = 'solar:bag-2-line-duotone',
    QUOTE_ALUMINIUM = 'solar:notes-line-duotone',
    QUOTE = 'solar:bill-check-line-duotone',
    QUOTE_QUOTE = 'solar:bill-list-line-duotone',
    QUOTE_ORDER = 'solar:cart-line-duotone',
    QUOTEDETAILTYPE_DOOR = 'material-symbols:door-open-outline',
    QUOTEDETAILTYPE_WINDOW = 'material-symbols:window-closed-outline',
    SIDE_LEFT = 'solar:mirror-left-bold-duotone',
    SIDE_RIGHT = 'solar:mirror-right-bold-duotone',
    DIMENSIONTYPE_HOLE = 'solar:black-hole-3-line-duotone',
    DIMENSIONTYPE_SHUTTER = 'solar:full-screen-square-line-duotone',

    TRUEFALSE_TRUE = 'solar:like-line-duotone',
    TRUEFALSE_FALSE = 'solar:dislike-line-duotone',

    PRICEGROUPMEASURE = 'solar:ruler-pen-line-duotone',
    PRICEMEASURE = 'solar:ruler-cross-pen-line-duotone',
    PRODUCTMODELOPTIONALGROUPMEASURE = 'solar:box-seam-line-duotone',
}


export enum DBLocalActionIcon {
    EDIT = 'solar:pen-line-duotone',
    CREATE = 'solar:plus-line-duotone',
    DELETE = 'solar:eraser-circle-line-duotone',
    VIEW = 'solar:eye-line-duotone',
    LIST = 'solar:bill-list-line-duotone',
    EXPORT = 'solar:export-line-duotone',
    DOWNLOAD = 'solar:download-line-duotone',
    DISABLE = 'solar:close-circle-line-duotone',
    ENABLE = 'solar:check-circle-line-duotone',
    SETPREFERRED = 'solar:star-circle-line-duotone',
    SETDEFAULT = 'solar:ticker-star-line-duotone',
    CLONE = 'solar:copy-line-duotone',
    ARCHIVE = 'solar:archive-line-duotone',
    RESTORE = 'solar:restart-circle-line-duotone',
    MANAGE = 'solar:widget-bold-duotone',
    CONNECT = 'solar:link-minimalistic-2-line-duotone',
    SEND = 'solar:map-arrow-right-bold-duotone',
    OTHER1 = 'solar:compass-square-line-duotone',
    OTHER2 = 'solar:leaf-bold-duotone',
    PRINT = 'solar:printer-line-duotone',
    DRAFT = 'solar:document-text-line-duotone',
    COMPLETE = 'solar:check-circle-line-duotone',
    CANCEL = 'solar:close-circle-line-duotone',
}


export enum DBLocalDocStatusIcon {
    NONE = 'mdi-close-circle-outline',
    DRAFT = 'solar:document-text-line-duotone',
    READY = 'solar:check-circle-line-duotone',
    SENT = 'solar:map-arrow-right-line-duotone',
    RECEIVED = 'solar:download-line-duotone',
    INPROGRESS = 'solar:infinity-bold-duotone',
    ONHOLD = 'solar:pause-line-duotone',
    COMPLETED = 'solar:check-circle-line-duotone',
    CANCELED = 'solar:close-circle-outline',
    ALL = 'solar:documents-line-duotone',
}